import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICardDetail, ICardDetailResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class AddCardCommand extends IRequestCommand<
  IAddCardResponse,
  ErrorDetails,
  IAddCardCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'passengers/{passengerUserId}/cards';
  public override setParameters(parameters: IAddCardCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.passengerUserId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IAddCardCommandParameters extends ICommandParameters {
  passengerUserId?: number,
  mercadopagoAppId: number,
  token: string,
  cardDetail?: ICardDetail,
  carrierId: number,
  placeId?: string,
}

export interface IAddCardResponse extends ICardDetailResponseDTO {
}
